import { back, persistChange } from 'app/_shared/events'
import actionByKey from 'app/_shared/events/action/byKey'

export default {
  onClose: {
    back,
  },
  onClick: {
    submit: actionByKey('submit'),
  },
  onSubmit: {
    submit: actionByKey('submit'),
  },
  onChange: {
    persistChange,
  },
}
